import { FC } from 'react'
import styles from 'components/features/pfm/LinkedAccountBalance/LinkedAccountBalanceUpdating.styl'
import Icon from 'components/atoms/Icon'

type LinkedAccountBalanceUpdatingProps = {

}
export const LinkedAccountBalanceUpdating: FC<LinkedAccountBalanceUpdatingProps> = () => {
  return (
    <div className={ styles.note }>
      <div className={ styles.icon }>
        <Icon kind='spinner-light' />
      </div>
      <div>
        Updating...
      </div>
    </div>
  )
}
